import { render, staticRenderFns } from "./ValeSalidaNew.vue?vue&type=template&id=21ab71ee&scoped=true&"
import script from "./ValeSalidaNew.vue?vue&type=script&lang=ts&"
export * from "./ValeSalidaNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ab71ee",
  null
  
)

export default component.exports